"use client";

import { initMixpanelBrowser, isProductAnalyticsEnabled } from "@lucien-ai/ts";
import { useEffect } from "react";

/**
 * Client-only Mixpanel bootstrap. Keeps the SDK out of the RSC graph and matches dashboard init options.
 */
export function MixpanelInit() {
  useEffect(() => {
    // Production: Next sets NODE_ENV=production for `next build` output. Override enables in `next dev` / non-prod.
    const enabled = isProductAnalyticsEnabled({
      isProduction: process.env.NODE_ENV === "production",
      override: process.env.NEXT_PUBLIC_PRODUCT_ANALYTICS_ENABLED,
    });
    if (!enabled) return;

    const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? "";
    if (!token) return;
    initMixpanelBrowser({
      token,
      debug: process.env.NODE_ENV !== "production",
      cookieDomain: process.env.NEXT_PUBLIC_MIXPANEL_COOKIE_DOMAIN || undefined,
    });
  }, []);

  return null;
}
